<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: student.full_name,
                        href: meta.links.student.show,
                    },
                    {
                        name: $tc('messages.links', 2),
                        href: null,
                    },
                ]"
            >
                <template v-slot:corner>
                    <div>
                        <ActivityMenuOptions>
                            <InertiaLink
                                v-for="otherStudent in meta.links.students"
                                :href="otherStudent.url"
                                :key="otherStudent.url"
                                class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                role="menuitem"
                            >
                                {{ otherStudent.text }}
                                <span v-if="otherStudent.quantity">({{ otherStudent.quantity }})</span>
                            </InertiaLink>
                        </ActivityMenuOptions>
                    </div>
                </template>
            </SmartBreadcrumbs>
        </template>

        <div class="w-full flex space-x-4 justify-end">
            <AppButton :href="meta.links.edit" element="InertiaLink">
                {{ $t('messages.edit') }}
            </AppButton>
        </div>

        <EmptyState picture v-if="links.length + fouls.length + familyInterviews.length === 0" />
        <template v-else>
            <LinkList :links="links" />

            <template v-if="fouls.length > 0">
                <h3 class="font-semibold mt-3">
                    {{ $tc('messages.fouls', 2) }}
                </h3>

                <template v-for="foul in fouls">
                    <a :href="foul.url" class="text-indigo-500">
                        {{ foul.text }}
                    </a>
                    <ul class="">
                        <li v-for="link in foul.links" class="ml-3">
                            <a :href="link.url" class="text-indigo-500">
                                <svg
                                    class="w-4 h-4 inline-block"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"
                                    ></path>
                                    <path
                                        d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"
                                    ></path>
                                </svg>

                                {{ link.text }}
                            </a>
                        </li>
                    </ul>
                </template>
            </template>

            <template v-if="familyInterviews.length > 0">
                <h3 class="font-semibold mt-3">
                    {{ $tc('messages.family_interviews', 2) }}
                </h3>

                <template v-for="familyInterview in familyInterviews">
                    <a :href="familyInterview.url" class="text-indigo-500">
                        {{ familyInterview.text }}
                    </a>
                    <ul class="">
                        <li v-for="link in familyInterview.links" class="ml-3">
                            <a :href="link.url" class="text-indigo-500">
                                <svg
                                    class="w-4 h-4 inline-block"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"
                                    ></path>
                                    <path
                                        d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"
                                    ></path>
                                </svg>

                                {{ link.text }}
                            </a>
                        </li>
                    </ul>
                </template>
            </template>
        </template>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import ActivityMenuOptions from '@/components/pageSpecific/ActivityMenuOptions.vue';
import EmptyState from '@/components/EmptyState.vue';
import LinkList from '@/components/LinkList.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        AppButton,
        LinkList,
        EmptyState,
        PanelPage,
        ActivityMenuOptions,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'student', 'links', 'fouls', 'familyInterviews'],
    data() {
        return {
            form: this.$inertia.form({}),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
